import React from 'react';
import { Router } from '@reach/router';
import GeneralLayout from '../components/GeneralLayout';
import HomePage from '../modules/Home/components/Home';
import TermPage from '../modules/Term/components/Term';
import PrivacyPage from '../modules/Privacy/components/Privacy';
import GetDemo from '../modules/TryRiskFree/components/GetDemo';
import TryRiskFree from '../modules/TryRiskFree/components/TryRiskFree';
import NotFound from '../modules/NotFound/components/NotFound';
import {
  HOME,
  TERMS_OF_USE,
  PRIVACY_POLICY,
  GET_DEMO,
  TRY_RISK_FREE,
  NOT_FOUND,
} from '../constants/Paths';

const RootRouter = () => (
  <Router>
    <GeneralLayout
      path={HOME}
      Child={HomePage}
    />
    <GeneralLayout
      path={GET_DEMO}
      Child={GetDemo}
    />
    <GeneralLayout
      path={TRY_RISK_FREE}
      Child={TryRiskFree}
    />
    <GeneralLayout
      path={TERMS_OF_USE}
      Child={TermPage}
    />
    <GeneralLayout
      path={PRIVACY_POLICY}
      Child={PrivacyPage}
    />
    <NotFound
      path={NOT_FOUND}
      default
    />
  </Router>
);

export default RootRouter;
